import { FormConfig } from '@workwave-tidal/core/form'
import { useMemo } from 'react'

import { useSegmentType } from '../../hooks/useSegmentType'
import { useOnSubmit } from './hooks/useOnSubmit'
import { useTexts } from './hooks/useTexts'

import { Footer } from './Footer'
import { FormContent } from './Form'

import { form } from './formState'
import type { RoadSegmentFormValues } from './types'
import { computeFormInitialValues } from './utils/computeFormInitialValues'

interface Props {
  roadSegment: uui.domain.client.rm.SegmentException
  creating?: boolean
}

export function SingleEdit(props: Props) {
  const { roadSegment, creating } = props
  const onSubmit = useOnSubmit(creating)
  const texts = useTexts()
  const segmentType = useSegmentType(roadSegment)

  const config = useMemo<FormConfig<RoadSegmentFormValues>>(
    () => ({
      id: 'road-editor-form',
      initialValues: computeFormInitialValues(roadSegment, segmentType),
    }),
    [roadSegment, segmentType],
  )

  return (
    <form.Form
      title={texts.edit}
      footer={<Footer />}
      config={config}
      onSubmit={onSubmit}
      rightBorder
      requireTransaction
      stopEditingOnUnmount
      applyPendingFitMapOnMount
    >
      <FormContent />
    </form.Form>
  )
}
